import type { home as en } from "../en/home";
import type { Messages } from "../types";

export const home: Messages<typeof en> = {
  greeting: {
    morning: "صباح الخير، {{name}}",
    afternoon: "مساء الخير، {{name}}",
    evening: "مساء الخير، {{name}}",
    summary: "إليك ما يحدث في {{scope}} اليوم.",
    allAccounts: "كل حساباتك",
  },
  quick: {
    compose: "إنشاء منشور",
    inbox: "فتح صندوق الوارد",
    approvals: "مراجعة الموافقات",
    reviewApprovals: "مراجعة الموافقات ({{n}})",
    assistant: "اسأل المساعد",
  },
  kpi: {
    title: "آخر 28 يوماً",
    reach: "الوصول",
    reachHint: "الحسابات الفريدة التي شاهدت محتواك",
    views: "المشاهدات",
    viewsHint: "عدد مرات عرض محتواك أو تشغيله",
    engagement: "التفاعل",
    engagementHint: "الإعجابات والتعليقات والمشاركات والحفظ",
    engagementRate: "{{rate}} من الوصول",
    followers: "المتابعون",
    followersHint: "إجمالي المتابعين الآن",
    vs: "مقارنة بالـ28 يوماً السابقة",
    noPrevious: "لا توجد بيانات سابقة بعد",
    trend: "اتجاه {{metric}} خلال آخر 28 يوماً",
  },
  sentiment: {
    title: "مشاعر التعليقات",
    description: "كيف يشعر الناس في تعليقاتك (28 يوماً)",
    total: "تعليق",
    empty: "لا توجد تعليقات في هذه الفترة بعد",
  },
  automation: {
    title: "أثر الأتمتة",
    description: "ما أنجزه ملفك نيابةً عنك (28 يوماً)",
    handled: "تمت معالجته",
    autoReplied: "رد تلقائي",
    hidden: "مخفي",
    saved: "وقت تم توفيره",
    manage: "إدارة القواعد",
  },
  approvals: {
    title: "بانتظار الموافقة",
    description: "مسودات الذكاء الاصطناعي التي تحتاج مراجعتك",
    empty: "لا شيء بالانتظار",
    emptyHint: "تصل هنا مسودات القواعد التي تتطلب الموافقة أولاً.",
    approved: "تمت الموافقة والإرسال",
    rejected: "تم الرفض",
    viewAll: "كل الموافقات",
    draft: "المسودة",
    noDraft: "بدون نص: إجراء فقط",
    kinds: {
      reply_public: "رد علني",
      reply_private: "رد خاص",
      send_message: "رسالة مباشرة",
      hide: "إخفاء تعليق",
      delete: "حذف تعليق",
      bulk: "إجراء جماعي",
    },
  },
  activity: {
    title: "النشاط المباشر",
    description: "التعليقات والرسائل الجديدة لحظة وصولها",
    empty: "هدوء حالياً",
    emptyHint: "ستظهر هنا التعليقات والرسائل الجديدة تلقائياً.",
    commented: "علّق",
    messaged: "أرسل رسالة",
    voiceNote: "رسالة صوتية",
    attachment: "مرفق",
    openInbox: "فتح الوارد",
    newBadge: "جديد",
  },
  bestTime: {
    title: "أفضل وقت للنشر",
    description: "متى يكون متابعوك أكثر نشاطاً",
    top: "أفضل موعد",
    schedule: "خطّط لمنشور",
  },
  upcoming: {
    title: "القادم",
    description: "المنشورات المجدولة",
    empty: "لا يوجد شيء مجدول",
    emptyHint: "خطّط لمنشورك القادم وسينشره ملفك في موعده.",
    calendar: "فتح التقويم",
  },
  guide: {
    title: "لنبدأ",
    progress: "أُنجز {{done}} من {{total}}",
    hide: "إخفاء هذا الدليل",
    show: "إظهار دليل البدء",
    done: "تم",
    todo: "لم يُنجز بعد",
    importing: "نستورد منشوراتك وتعليقاتك الأخيرة من @{{user}}…",
    inboxReady: "صندوق الوارد جاهز",
    steps: {
      connect: "اربط إنستغرام",
      import: "استورد منشوراتك وتعليقاتك",
      reply: "رُدّ على تعليق بمساعدة الذكاء الاصطناعي",
      rule: "شغّل قاعدتك الأولى",
      invite: "ادعُ زميلاً",
      post: "خطّط لمنشورك القادم",
    },
  },
  attention: {
    reconnect_zero: "لا حسابات تحتاج إلى إعادة الربط.",
    reconnect_one: "يجب إعادة ربط ⁨@{{user}}⁩ قبل أن تتمكن منصة ملفك من القراءة أو الرد.",
    reconnect_two: "يجب إعادة ربط حسابين قبل أن تتمكن منصة ملفك من القراءة أو الرد.",
    reconnect_few: "يجب إعادة ربط {{count}} حسابات قبل أن تتمكن منصة ملفك من القراءة أو الرد.",
    reconnect_many: "يجب إعادة ربط {{count}} حسابًا قبل أن تتمكن منصة ملفك من القراءة أو الرد.",
    reconnect_other: "يجب إعادة ربط {{count}} حساب قبل أن تتمكن منصة ملفك من القراءة أو الرد.",
    reconnectAction: "إعادة الربط",
  },
  crisis: {
    title: "ارتفاع في التعليقات السلبية",
    body_zero: "{{count}} تعليق سلبي خلال آخر 24 ساعة، أي نحو {{times}}× المعدل اليومي المعتاد.",
    body_one: "تعليق سلبي واحد خلال آخر 24 ساعة، أي نحو {{times}}× المعدل اليومي المعتاد.",
    body_two: "تعليقان سلبيان خلال آخر 24 ساعة، أي نحو {{times}}× المعدل اليومي المعتاد.",
    body_few: "{{count}} تعليقات سلبية خلال آخر 24 ساعة، أي نحو {{times}}× المعدل اليومي المعتاد.",
    body_many: "{{count}} تعليقًا سلبيًا خلال آخر 24 ساعة، أي نحو {{times}}× المعدل اليومي المعتاد.",
    body_other: "{{count}} تعليق سلبي خلال آخر 24 ساعة، أي نحو {{times}}× المعدل اليومي المعتاد.",
    action: "راجِع الآن",
    dismiss: "إغلاق",
  },
  error: "تعذّر تحميل لوحة التحكم",
};
